import { render, staticRenderFns } from "./UserResetPassword.vue?vue&type=template&id=334276df&"
import script from "./UserResetPassword.vue?vue&type=script&lang=js&"
export * from "./UserResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports